import React, { useState } from "react"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"

const FollowupReportTabComponent = ({ data, name, dateFormat,mode }) => {
  const tableStyle = {
    border: "1.5px solid rgb(228, 225, 225)",
    borderCollapse: "collapse",
    borderRadius: "4px",
    marginTop: "20px",
    marginLeft: "20px", // Add left margin
    marginRight: "20px", // Add right margin
    // overflowX: "auto",
  }


  const thStyle = {
    border: "1.5px solid rgb(228, 225, 225)",
    borderCollapse: "collapse",
    backgroundColor: "#f2f3f3",
    padding: "17px",
    fontSize: "14px",
    width: "150px",
  }

  const tdStyle = {
    border: "1.5px solid rgb(228, 225, 225)",
    borderCollapse: "collapse",
    padding: "15px 20px",
  }

  const buttonStyle = {
    backgroundColor: "#E40D8C",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "2px",
    fontSize: "13px",
    cursor: "pointer",
    marginTop: "60px",
  }

  //paging
  const itemsPerPage = 10 // Number of items to display per page
  const [currentPage, setCurrentPage] = useState(1)

  // Calculate the index range for the current page
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage

  // Slice the data array to get the items for the current page
  const currentPageData = data.slice(startIndex, endIndex)

  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }
  console.log(mode)
  ///excel functionality
  const [isLoading, setIsLoading] = useState(false)
  const totalPages = Math.ceil(data.length / itemsPerPage)
  const displayPages = 5 // Number of pagination buttons to display

  const renderPaginationButtons = () => {
    const buttons = []
    const start = Math.max(1, currentPage - Math.floor(displayPages / 2))
    const end = Math.min(start + displayPages - 1, totalPages)

    for (let i = start; i <= end; i++) {
      buttons.push(
        <button
          key={i}
          style={{
            backgroundColor: currentPage === i ? "#E40D8C" : "#FFFFFF",
            color: currentPage === i ? "white" : "#74788D",
            border:
              currentPage === i ? "1px solid #E40D8C" : "1px solid #74788D",
            padding: "5px 10px",
            marginRight: "5px",
            cursor: "pointer",
          }}
          onClick={() => handlePageChange(i)}
          disabled={currentPage === i}
        >
          {i}
        </button>
      )
    }
    return buttons
  }
  const downloadFile = ({ csvdata, fileName, fileType }) => {
    const blob = new Blob([csvdata], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const downloadCsv = () => {
    setIsLoading(true)

    const ExportDataTable =
      data.length > 0
        ? data.map((item, index) => {
          const remarks = !isEmpty(item.futureRemarks)
            ? item.futureRemarks.replace(/[\r\n,.]/gm, "")
            : "--"
          const eventName =
            item && item.eventName && item.eventName.length > 0
              ? item.eventName.map((m) => m).join(",")
              : ""
          const eventDate =
            item && item.eventDate && item.eventDate.length > 0
              ? item.eventDate
                .map((m) => moment(m).format(dateFormat))
                .join(",")
              : "--"
          const previousFollowupRemarks = !isEmpty(item.previousFollowupRemarks)
            ? item.previousFollowupRemarks.replace(/[\r\n,.]/gm, "")
            : "--"
          const currentDay = moment().startOf("day")
          const updateOn = item.futureFollowupDate
            ? moment.utc(item.futureFollowupDate).startOf("day")
            : ""
          const updateDifference =
            currentDay && updateOn
              ? updateOn.isValid() && currentDay.isValid()
                ? Math.ceil(currentDay.diff(updateOn, "days", true))
                : "--"
              : "--"
          const lastStatusValue =
            updateDifference !== "--" ? `${updateDifference} days` : "--"
          const followupReason = item && item.followupReason && item.followupReason.length > 0 ?
            item.followupReason.map(m => m.reasonName).join(",") : ""
          const followupReasonValue = !isEmpty(followupReason)
            ? followupReason.replace(/[\r\n,.]/gm, "")
            : "--"
            const eventNameValue = JSON.stringify(eventName).replace(
              /","/g,
              "\n"
          )
          const eventDateValue = JSON.stringify(eventDate).replace(
            /","/g,
            "\n"
        )
          return {
            _id: index,
            sNo: index + 1,
            leadNo: item.leadNo || "--",
            isEscalation: item.isEscalation == true ?
              "YES" : item.isEscalation == false ? "NO" : "--",
            clientCode: item.clientCode || "--",
            clientName: item.clientName || "--",
            clientStatus: item.clientStatus || "--",
            brideName: item.brideName || "--",
            groomName: item.groomName || "--",
            eventName: eventNameValue || "--",
            eventDate: eventDateValue,
            previousFollowupDate: item.previousFollowupDate ? moment(item.previousFollowupDate).format(dateFormat) : "--",
            modeOfFollowup: item.modeOfFollowup || "--",
            futureRemarks: remarks,
            aging: lastStatusValue,
            previousFollowupRemarks: previousFollowupRemarks,
            followupStatus: item.followupStatus || "--",
            followupReason: followupReasonValue,
            openFollowupCount:item.openFollowupCount||"--",
            futureFollowupDate:item.futureFollowupDate ? moment(item.futureFollowupDate).format(dateFormat) : "--",

          }

        })
        : []
    setTimeout(() => {
      let headerData = [
        `${mode===2?"S.No,Lead No,Bride Name,Groom Name,Event, Event Date,":"S.No,Lead No,Bride Name,Groom Name,Event, Event Date,Open Followup Count,Previous Followup date,Previous Followup Remarks,Mode Of Followup,Followup Reason,Future Followup Date,Future Followup Remarks,Aging date"}`
      ]
      let usersCsv = ExportDataTable.reduce((acc, user) => {
        if(mode===2){
          const {
            sNo,
            leadNo,
            brideName,
            groomName,
            eventName,
            eventDate
          } = user
          acc.push([
            sNo,
            leadNo,
            brideName,
            groomName,
            eventName,
            eventDate
          ])
        } else{
          const {
            sNo,
            leadNo,
            brideName,
            groomName,
            eventName,
            eventDate,
            openFollowupCount,
            previousFollowupDate,
            previousFollowupRemarks,
            modeOfFollowup,
            followupReason,
            futureFollowupDate,
            futureRemarks,
            aging
          } = user
          acc.push([
            sNo,
            leadNo,
            brideName,
            groomName,
            eventName,
            eventDate,
            openFollowupCount,
            previousFollowupDate,
            previousFollowupRemarks,
            modeOfFollowup,
            followupReason,
            futureFollowupDate,
            futureRemarks,
            aging
          ])
        }
     

        return acc
      }, [])

      downloadFile({
        csvdata: [...headerData, ...usersCsv].join("\n"),
        fileName: "FollowupReportDetails.csv",
        fileType: "text/csv",
      })
      setIsLoading(false)
    }, 500)

  }
  return (
    <div style={{ overflowX: "auto" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <h5>{name}</h5>

        {isLoading ? (
          <button style={buttonStyle} disabled>
            <span className="spinner" /> Downloading...
          </button>
        ) : (
          <button
            style={buttonStyle}
            onClick={() => downloadCsv()}
          >
            Download
          </button>
        )}
      </div>

      <div
        style={{
          overflowX: "auto",
          maxWidth: "1300px",
          maxHeight: "500px",
          marginTop: "20px",
          padding: "0 10px",
        }}
      >
       {mode === 2?(<table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>S.No</th>
              <th style={thStyle}>Lead Number</th>
              <th style={thStyle}>Bride Name</th>
              <th style={thStyle}>Groom Name</th>
              <th style={thStyle}>Event</th>
              <th style={thStyle}>Event Date</th>

            </tr>
          </thead>
          <tbody>
            {currentPageData && currentPageData.length > 0 ? (
              currentPageData.map((item, index) => {
                const eventName =
                  item && item.eventName && item.eventName.length > 0
                    ? item.eventName.map((m) => m).join(",")
                    : "--"
                const eventDate =
                  item && item.eventDate && item.eventDate.length > 0
                    ? item.eventDate
                      .map((m) => moment(m).format(dateFormat))
                      .join(",")
                    : "--"
            
                return (
                  <>
                    <tr key={index}>
                      <td style={tdStyle}>{index + 1}</td>
                      <td style={tdStyle}>{item.leadNo}</td>
                      <td style={tdStyle}>
                        {item.brideName ? item.brideName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.groomName ? item.groomName : "--"}
                      </td>
                      <td style={tdStyle}>{eventName}</td>
                      <td style={tdStyle}>{eventDate}</td>
                    </tr>
                  </>
                )

              })
            ) : (
              <>
                <tr key={0}>
                  <td colSpan={6} style={{ ...tdStyle, textAlign: "center" }}>
                    No record found
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>):
        (
             <table style={tableStyle}>
             <thead>
               <tr>
                 <th style={thStyle}>S.No</th>
                 <th style={thStyle}>Lead Number</th>
                 <th style={thStyle}>Bride Name</th>
                 <th style={thStyle}>Groom Name</th>
                 <th style={thStyle}>Event</th>
                 <th style={thStyle}>Event Date</th>
                 <th style={thStyle}>Open Followup Count</th>
                 <th style={thStyle}>Previous Followup Date</th>
                 <th style={thStyle}>Previous Followup Remarks</th>
                 <th style={thStyle}>Followup Mode</th>
                 <th style={thStyle}>Followup Reason</th>
                 <th style={thStyle}>Future Followup Date</th>
                 <th style={thStyle}>future followup remarks
                 </th>
                  <th  style={thStyle}>Aging date</th>
               </tr>
             </thead>
             <tbody>
               {currentPageData && currentPageData.length > 0 ? (
                 currentPageData.map((item, index) => {
                   const eventName =
                     item && item.eventName && item.eventName.length > 0
                       ? item.eventName.map((m) => m).join(",")
                       : "--"
                   const eventDate =
                     item && item.eventDate && item.eventDate.length > 0
                       ? item.eventDate
                         .map((m) => moment(m).format(dateFormat))
                         .join(",")
                       : "--"
                  //  const previousAttachment = item.previousCallFollowupAttachment ? item.previousCallFollowupAttachment : []
                  //  const attachmentURL = !isEmpty(previousAttachment) ? previousAttachment[0] : ""
                  //  const splitAttach = !isEmpty(
                  //    attachmentURL
                  //  )
                  //    ? attachmentURL.split(".")
                  //    : ""
                  //  const attachExtension = !isEmpty(
                  //    splitAttach
                  //  )
                  //    ? splitAttach.pop()
                  //    : ""
                   const currentDay = moment().startOf("day")
                   const updateOn = item.futureFollowupDate
                     ? moment.utc(item.futureFollowupDate).startOf("day")
                     : ""
                   const updateDifference =
                     currentDay && updateOn
                       ? updateOn.isValid() && currentDay.isValid()
                         ? Math.ceil(currentDay.diff(updateOn, "days", true))
                         : "--"
                       : "--"
                   const lastStatusValue =
                     updateDifference !== "--" ? `${updateDifference} days` : "--"
                   const followupReason = item && item.followupReason && item.followupReason.length > 0 ?
                     item.followupReason.map(m => m.reasonName).join(",") : ""
                   return (
                     <>
                       <tr key={index}>
                         <td style={tdStyle}>{index + 1}</td>
                         <td style={tdStyle}>{item.leadNo}</td>
                         <td style={tdStyle}>
                           {item.brideName ? item.brideName : "--"}
                         </td>
                         <td style={tdStyle}>
                           {item.groomName ? item.groomName : "--"}
                         </td>
                         <td style={tdStyle}>{eventName}</td>
                         <td style={tdStyle}>{eventDate}</td>
                         <td style={tdStyle}>{item.openFollowupCount || "--"}</td>
                         <td style={tdStyle}>{item.previousFollowupDate ? moment(item.previousFollowupDate).format(dateFormat) : "--"}</td>
                         <td style={tdStyle}>{item.previousFollowupRemarks ? item.previousFollowupRemarks : "--"}</td>
                          <td style={tdStyle}>{item.modeOfFollowup || "--"}</td>
                          <td style={tdStyle}>{followupReason || "--"}</td>
                          <td style={tdStyle}>{item.futureFollowupDate?moment(item.futureFollowupDate).format(dateFormat):"--"}</td>
                         <td style={tdStyle}>
                           {item.futureRemarks ? item.futureRemarks : "--"}
                         </td>
                         <td style={tdStyle}>
                           {lastStatusValue}
                         </td>
                         {/* <td style={tdStyle}>
                           {previousAttachment.length > 0 ? ((attachmentURL &&
                             attachExtension === "jpeg") ||
                             (attachmentURL &&
                               attachExtension === "jpg") ||
                             (attachmentURL &&
                               attachExtension === "png") ? (
                             <a
                               onClick={() =>
                                 window.open(
                                   attachmentURL,
                                   "_blank"
                                 )
                               }
                             >
                               <span
                                 style={{
                                   textDecoration: "underline",
                                   color: "#E40D8C",
                                   cursor:"pointer"
                                 }}
                               >
                                 View
                               </span>
                             </a>
                           ) : (attachmentURL &&
                             attachExtension === "mp3") ||
                             (attachmentURL &&
                               attachExtension === "m4a") ||
                             (attachmentURL &&
                               attachExtension === "mp4") ? (
                             <a href={attachmentURL}>
                               <audio controls>
                                 <source
                                   src={attachmentURL}
                                   type="audio/mpeg"
                                 />
                                 Your browser does not support
                                 the audio element.
                               </audio>
                             </a>
                           ) : (
                             "--"
                           )) : ("--")}
                         </td> */}
                       </tr>
                     </>
                   )
   
                 })
               ) : (
                 <>
                   <tr key={0}>
                     <td colSpan={17} style={{ ...tdStyle, textAlign: "center" }}>
                       No record found
                     </td>
                   </tr>
                 </>
               )}
             </tbody>
           </table>
        )}
     
        </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        {/* Showing rows information */}
        <p style={{ margin: "0", float: "left" }}>
          Showing rows {currentPageData.length > 0 ? startIndex + 1 : 0} to{" "}
          {Math.min(endIndex, data.length)} of {data.length}
        </p>
        {/* Pagination buttons */}
        <div style={{ float: "right" }}>
          <button
            style={{
              backgroundColor: "#FFFFFF",
              color: "#74788D",
              border: "1px solid #74788D",
              padding: "5px 10px",
              marginRight: "5px",
              cursor: "pointer",
            }}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          {renderPaginationButtons()}
          <button
            style={{
              backgroundColor: "#FFFFFF",
              color: "#74788D",
              border: "1px solid #74788D",
              padding: "5px 10px",
              marginRight: "5px",
              cursor: "pointer",
            }}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  )
}

FollowupReportTabComponent.propTypes = {
  data: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  statusPayload: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  dateFormat: PropTypes.string,
  date: PropTypes.string,
  mode:PropTypes.any
}

export default FollowupReportTabComponent
